export default __webpack_public_path__ + "static/media/Mystic's Leggings of the Soaring Heart.6e3c5546.jpg";